import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
/**
 * Get Roles.
 * @param commit
 * @param dispatch
 */
export function getRoles(_ref) {
  var commit = _ref.commit,
    dispatch = _ref.dispatch;
  dispatch('api', {
    url: 'roles?include=permissions',
    commitAfter: 'roles/ROLES',
    wait: 'get-roles'
  }, {
    root: true
  }).then(function (response) {
    commit('ROLES', response.data);
  });
}

/**
 * Store new Role.
 *
 * @param commit
 * @param dispatch
 * @param data
 * @returns {Promise|Q.Promise<any>|Promise<any>|PromiseLike<any>}
 */
export function storeRole(_ref2, data) {
  var commit = _ref2.commit,
    dispatch = _ref2.dispatch;
  return dispatch('api', {
    url: 'roles',
    method: 'post',
    data: data,
    wait: 'store-role'
  }, {
    root: true
  }).then(function (response) {
    commit('ROLE', response.data);
    return Promise.resolve(response);
  });
}

/**
 * Get specific role by ID.
 *
 * @param state
 * @param commit
 * @param dispatch
 * @param id
 * @returns {*}
 */
export function getRole(_ref3, id) {
  var state = _ref3.state,
    commit = _ref3.commit,
    dispatch = _ref3.dispatch;
  return dispatch('api', {
    url: 'roles/' + id + '?include=permissions',
    wait: 'get-role'
  }, {
    root: true
  }).then(function (response) {
    commit('ROLE', response.data);
  });
}

/**
 * Update role.
 *
 * @param commit
 * @param dispatch
 * @param data
 * @returns {*}
 */
export function updateRole(_ref4, data) {
  var commit = _ref4.commit,
    dispatch = _ref4.dispatch;
  return dispatch('api', {
    url: 'roles/' + data.id,
    method: 'put',
    data: data.form,
    wait: 'update-role',
    files: true,
    commitAfter: 'roles/ROLE'
  }, {
    root: true
  });
}

/**
 * Delete role.
 *
 * @param commit
 * @param dispatch
 * @param id
 * @returns {*}
 */
export function deleteRole(_ref5, id) {
  var commit = _ref5.commit,
    dispatch = _ref5.dispatch;
  return dispatch('api', {
    url: 'roles/' + id,
    method: 'delete',
    wait: 'delete-role'
  }, {
    root: true
  });
}